<div class="modal-header">
  <fa-icon [icon]="isWarning ? 'exclamation-triangle' : 'exclamation-circle'" [fixedWidth]="true" class="me-3" size="2x"
    [ngClass]="isWarning ? 'text-warning' : 'text-danger'"/>
  <h4 class="modal-title">{{title}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  @if (header) {
    <h5 class="mb-4">{{header}}</h5>
  }
  @if (text) {
    <p>{{text}}</p>
  }
  @if (errors) {
    <!-- Using `$index` for identity tracking because error messages can repeat -->
    @for (err of errors; track $index) {
      <p>{{ err }}</p>
    }
  }
</div>
<div class="modal-footer">
  <button type="button" ngbAutofocus class="btn btn-primary" (click)="activeModal.dismiss('Close')">{{ 'Close' | messageTranslate }}</button>
</div>
